define('views/modules/profile/blocks/preferences-business',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/user',
    // events
    'services/events/user-events',
    // views
    'views/parts/info-section',
    'views/modules/profile/edit/preferences-edit-panel-business',
    // templates
    'text!templates/modules/profile/blocks/preferences-business.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    User,
    // events
    UserEvents,
    // views
    VInfoSection,
    VPreferencesEditPanelBusiness,
    // templates
    TPreferencesBusiness
) {

    var VBlockPreferencesBusiness = Backbone.Epoxy.View.extend({
        template: TPreferencesBusiness,

        initialize: function(opt) {
            _.extend(this, {
                group: opt.group
            });

            this.view = {
                info: new VInfoSection({
                    title: "Preferences",
                    icon: "sl-icon-settings",
                    //help: "messages:helpbox-preferences-view",
                    buttonBottom: {
                        text: "Edit your preferences",
                        context: this,
                        callback: this.onEditPreferences
                    },
                })
            };

            this.listenTo(UserEvents, 'profile:update', this.onProfileUpdated);
        },

        render: function() {
            var view = this.view,
                html = Mustache.render(this.template, Mustache.getContext(
                    _.extend({
                        daysBeforeCalendarItemsAreHidden: User.getMainGroup().daysBeforeCalendarItemsAreHidden,
                        disable_animated_sessions: User.getMainGroup().disable_animated_sessions,
                        isOwner: User.getMainGroup().isOwner,
                        favorite_exercises_type_title: this.getFavoriteExercisesType()
                    }, this.model.toJSON())
                ));

            this.assign(view.info, this.$el) // must be first
                .generateZones();

            view.info.setContent(html);

            this.applyBindings();

            return this;
        },

        getFavoriteExercisesType: function() {
            switch (this.model.get('favorite_exercises_type')) {
                case '3D': return 'exercises-3d';
                case 'live': return 'exercises-live';
                case 'both': return 'both';
            };
        },

        onEditPreferences: function(e) {
            e.preventDefault();
            var view = this.view,
                panel = view.edit || (view.edit = new VPreferencesEditPanelBusiness({
                    model: this.model,
                    group: this.group
                }));
            this.trigger('panel:stack', panel);
        },

        onProfileUpdated: function() {
            this.when(this.model.fetch({ force: true })).then(function()  {
                this.render();
            }, this);
        }
    });

    return VBlockPreferencesBusiness;
});

